import { failure } from './failure';
import { success } from './success';
import { request } from './request';

export const messages = {
  failure,
  request,
  success,
} as const;
